import React from 'react';
import { Route, IndexRedirect } from 'react-router';
import { Tracking } from 'web-core/src/tracking';
import TranslationProvider from 'client/components/translationProvider';
import App from './app';
import GuideContainer from './guideContainer';

function bindPageViewTracking() {
  return () => {
    Tracking.trackPageView();
  };
}

export default (
  <Route path="/" component={App}>
    <Route component={TranslationProvider} keys={['app', 'common', 'healthGuide']}>
      <IndexRedirect to="/guide" />
      <Route
        path="guide(/:section(/:subsection))"
        component={GuideContainer}
        onEnter={bindPageViewTracking()} />
    </Route>
  </Route>
);
